import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { Store, select } from "@ngrx/store";
import { AppState } from "../../../app.state";
import { IEmpresa } from "../../../interfaces/catalogos.";
import { LoadingService } from "../../../loading/loading.service";
import { EmpresaService } from "../../../services/catalogos/empresa/empresa.service";
import { showHideCatalogo } from "../../../states/admon-catalogos/actions";
import { selectCatalogoEmpresaStatus } from "../../../states/admon-catalogos/selector";
import { cargaEmpresa } from "../../../states/catalogos/actions";
import {
  campoRequerido,
  descripcionCatalogo,
  existeValorDuplicado
} from "../../utils";

@Component({
  selector: "app-add-empresa",
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: "./add-edit.component.html",
  styleUrl: "./add-edit.component.css",
})
export class AddEditEmpresaComponent {
  @Output() mostrarBotones: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() empresas: IEmpresa[] = [];
  private store: Store<AppState> = inject(Store);
  admonCatEmpresaStatus$ = this.store.pipe(select(selectCatalogoEmpresaStatus));

  nuevo = false;

  existe = false;
  nuevoRegistro!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private empresaService: EmpresaService,
    private loadingService: LoadingService
  ) {}

  ngOnInit() {
    console.log("empresas ", this.empresas);
    this.init();
  }

  init() {
    this.nuevoRegistro = this.fb.group({
      descripcion: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
          descripcionCatalogo(),
          campoRequerido(),
        ],
      ],
    });
  }
  cancelar() {
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "empresas",
        mostrarEditar: false,
        mostrarNuevo: false,
        guardando: false,
      })
    );
    this.init();
  }

  guardarRegistro() {
    this.loadingService.show();
    if (this.nuevoRegistro.valid) {
      // Aquí puedes realizar la lógica para guardar el comentario
      console.log("Comentario guardado:", this.nuevoRegistro.value.descripcion);
      this.empresaService
        .guardarEmpresa(this.nuevoRegistro.value.descripcion)
        .subscribe((data) => {
          if (!data.error) {
            this.init();
            this.store.dispatch(
              showHideCatalogo({
                tipoCatalogo: "empresas",
                mostrarEditar: false,
                mostrarNuevo: false,
                guardando: false,
              })
            );
            this.store.dispatch;
          }
          this.loadingService.hide();
        });
    }
  }

  ocultarBotones(ocultar: boolean) {
    this.mostrarBotones.emit(ocultar);
  }

  existeRegistro(control: any, currentValue: any) {
    existeValorDuplicado(control, this.empresas, currentValue);
  }
  nuevaEmpresa() {
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "empresas",
        mostrarEditar: false,
        mostrarNuevo: true,
        guardando: false,
      })
    );
  }

  updateCatalogo() {
    this.empresaService.cargarEmpresas().subscribe(
      (response) => {
        this.empresas = response;
        console.log("Empresas cargadas:", this.empresas);
        this.loadingService.hide();
        // Realizar otras acciones después de cargar las empresas
        console.log("Cargamos empresas en app store");
        this.store.dispatch(cargaEmpresa({ catEmpresa: response }));
      },
      (error) => {
        this.loadingService.hide();
        console.error("Error al cargar empresas:", error);
        // Manejar el error de carga de empresas
      }
    );
  }
}
